import { render, staticRenderFns } from "./StripePayoutDetail.vue?vue&type=template&id=2a8f27bd"
import script from "./StripePayoutDetail.vue?vue&type=script&lang=ts"
export * from "./StripePayoutDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports